// @flow
// ----------------------------------------------------------------------
// <copyright file="Izenda.PasswordPolicies.js" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
//  </copyright>
// ----------------------------------------------------------------------

import React from 'react';
import connect from 'share/enhancers/Izenda.Connect';
import Panel from 'share/components/controls/Izenda.Panel';
import PasswordComplexity from './Izenda.PasswordComplexity';
import PasswordValidity from './Izenda.PasswordValidity';
import PasswordExpiryNotification from './Izenda.PasswordExpiryNotification';
import PasswordHistory from './Izenda.PasswordHistory';
import PasswordLink from './Izenda.PasswordLink';
import SecurityQuestions from './Izenda.SecurityQuestions';
import action from 'modules/Settings/SystemConfiguration/SecurityPolicies/Izenda.SecurityPoliciesDetailAction';

const Header = connect()(function(props: any) {
  const localization = props.localization;
  return (
    <div onClick={props.collapseToggle}>
      <i className='icon-toggle-triangle' />
      <label className='panel-title'>
        {localization.getText('SYSTEM_CONFIGURATION_SECURITY_POLICIES_LABEL_PASSWORD_POLICY')}
      </label>
    </div>
  );
});

const PasswordPolicies = connect(action)(function(props: any) {
  const header = {
    component: Header
  };

  return (
    <Panel className='u_fullHeight u_noMarginAll' header={header} collapsible expanedOption>
      <PasswordComplexity {...props} />
      <PasswordValidity {...props} />
      <PasswordExpiryNotification {...props} />
      <PasswordHistory {...props} />
      <PasswordLink {...props} />
      <SecurityQuestions {...props} />
    </Panel>
  );
});

export default PasswordPolicies;



// WEBPACK FOOTER //
// ./ui/modules/Settings/SystemConfiguration/SecurityPolicies/PasswordPolicies/Izenda.PasswordPolicies.js